import React from "react";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  tone?: "page" | "raised" | "ink";
  spacing?: "default" | "tight" | "loose";
  hairlineTop?: boolean;
  hairlineBottom?: boolean;
}

const TONE: Record<NonNullable<SectionProps["tone"]>, string> = {
  page:   "bg-cream-50 text-coffee-900 dark:bg-coffee-900 dark:text-cream-50",
  raised: "bg-cream-100 text-coffee-900 dark:bg-coffee-800 dark:text-cream-50",
  ink:    "bg-coffee-900 text-cream-50 dark:bg-coffee-50 dark:text-coffee-900",
};

const SPACING: Record<NonNullable<SectionProps["spacing"]>, string> = {
  tight:   "py-16 sm:py-20",
  default: "py-20 sm:py-28 lg:py-32",
  loose:   "py-28 sm:py-36 lg:py-44",
};

export function Section({
  tone = "page",
  spacing = "default",
  hairlineTop,
  hairlineBottom,
  className = "",
  children,
  ...rest
}: SectionProps) {
  const cls = [
    TONE[tone],
    SPACING[spacing],
    hairlineTop ? "border-t border-latte-300 dark:border-latte-800" : "",
    hairlineBottom ? "border-b border-latte-300 dark:border-latte-800" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={cls} {...rest}>
      {children}
    </section>
  );
}

export default Section;
